import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '../../baseClasses/BaseComponent'; 
import RelativePopout from '../RelativePopout';
import removeIcon from '../../assets/images/close-icon-white.svg';
import './FilterTags.scss';

export default class FilterTags extends BaseComponent {
  constructor(props) {
    super(props);
    FilterTags.propTypes = {
      filters: PropTypes.array,
      handleFilterRemoved: PropTypes.func,
    };
    this.state = {
      showRemaining: false,
    };
    this.remainingStartIndex = -1;
    this.remainingStartOffset = 0;
    this.handleShowRemaining = this.handleShowRemaining.bind(this);
  }

  buildItemsForFilters() {
    let items = [];
    if (this.container) {
      const { filters } = this.props;
      if (filters) {
        const maxWidth = this.container.offsetWidth;
        this.remainingStartIndex = -1;
        this.remainingStartOffset = 0;
        let itemsWidth = 0;
        if (filters.length > 1) {
          // add "clear" button item...
          items.push(
            <div className="filtertags-item-clear" key={-1}>
              <div className="filtertags-item-clear-text" onClick={this.handleRemoveFilter} data-index={-1}>CLEAR</div>
            </div>
          );
          itemsWidth += 28;
        }
        if(filters.length > 0) {
          for (const [index, filter] of filters.entries()) {
            const filterName = filter.name ? filter.name : filter;
            const itemWidth = filterName.length * 5 + 22;

            if (itemsWidth + itemWidth + (index + 1 < filters.length ? 20 : 0) > maxWidth) {
              this.remainingStartIndex = index;
              this.remainingStartOffset = itemsWidth - 20;
              // create item that will lead to dropdown showing remaining filters
              items.push(
                <div className="filtertags-item" key={index} onClick={this.handleShowRemaining} ref={e => {this.dropDownElement = e;}}>
                  <div className="filtertags-item-name">+ {filters.length - index}</div>
                </div>
              );
              break;
            } else {
              items.push(
                <div className="filtertags-item" key={index}>
                  <div className="filtertags-item-name">{filterName}</div>
                  <img className="filtertags-item-remove" src={removeIcon} alt="Remove this filter" onClick={this.handleRemoveFilter} data-index={index}/>
                </div>
              );
              itemsWidth += itemWidth;
            }
          }
        }
      }
    }
    return items;
  }

  handleShowRemaining() {
    this.setState({ showRemaining: true });
    document.addEventListener('click', this.handleClickOutside, false);
  }

  handleHideRemaining() {
    const { showRemaining } = this.state;
    if (showRemaining) {
      this.setState({ showRemaining: false });
      document.removeEventListener('click', this.handleClickOutside, false);
    }
  }

  handleClickOutside(event) {
    if (this.remainingPopout && !this.remainingPopout.contains(event.target)) {
      this.handleHideRemaining();
    }
  }

  handleBackgroundClick(e) {
    this.handleHideRemaining();
  }

  handleRemoveFilter(e) {
    e.stopPropagation();
    const { index } = e.target.dataset;
    const { filters, handleFilterRemoved } = this.props;
    if (index < 0) {
      // remove all
      handleFilterRemoved(filters);
    } else {
      handleFilterRemoved([filters[index]]);
    }
    this.handleHideRemaining();
  }

  render() {
    const { showRemaining } = this.state;
    const items = this.buildItemsForFilters();
    let background = null;
    let showRemainingView = null;
    if (showRemaining) {
      const { filters } = this.props;
      let remainingItems = [];
      for (let i = this.remainingStartIndex; i < filters.length; i++) {
        const filter = filters[i];
        const filterName = filter.name ? filter.name : filter;
        remainingItems.push(
          <div className="filtertags-item-remaining" key={i}>
            <div className="filtertags-item-name">{filterName}</div>
            <img className="filtertags-item-remove" src={removeIcon} alt="Remove this filter" onClick={this.handleRemoveFilter} data-index={i} />
          </div>
        );
      }

      if (!this.props.positionRight) {
        const top = this.props.isDashboard ? 15 : this.container.getBoundingClientRect().top + 15;
        const left = this.props.isDashboard ? this.remainingStartOffset : this.container.getBoundingClientRect().left + this.remainingStartOffset;
        showRemainingView = (
          <div ref={el => { this.remainingPopout = el; }} >
            <RelativePopout
              top={top}
              left={left}
              arrowLocation='top'
            >
              <div className="filtertags-remaining-container">
                {remainingItems}
              </div>
            </RelativePopout>
          </div>
        );
      }
      else {
        const top = 5;
        let right = 0;
        if (this.dropDownElement) {
          const rect = this.dropDownElement.getBoundingClientRect();
          const parentRect = this.dropDownElement.parentElement.getBoundingClientRect();
          right = parentRect.width - (rect.left - parentRect.left) - (rect.width * 1.75);
        }
        showRemainingView = (
          <div style={{ position: 'absolute', top: top, right: right, width: '100%', height: 30 }} ref={el => { this.remainingPopout = el; }} >
            <RelativePopout
              top={0}
              right={0}
              arrowLocation='top-right'
            >
              <div className="filtertags-remaining-container">
                {remainingItems}
              </div>
            </RelativePopout>
          </div>
        );
      }
    }
    return (
      <div className="filtertags-container" ref={el => (this.container = el)}>
        { background }
        { items }
        { showRemainingView }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FilterTags/index.js